import { forwardRef, PropsWithChildren } from "react";

import { colors } from "#app/theme/v1/colors";
import { Icon, IconName } from "#shared/icons/Icon";
import { Button, ButtonProps } from "#shared/view/designSystem/Button";

const styles = {
  buttonGradient: {
    color: "white",
    borderColor: colors.blue[5],
    background: "linear-gradient(340deg, rgba(70,117,245,1) 0%, rgba(151,71,255,1) 90%)",
  },
};

type Props = {
  onClick: () => void;
  icon?: IconName;
  props?: ButtonProps;
};

export const AIButton = forwardRef<HTMLButtonElement, ButtonProps & Props>(
  ({ children, onClick, icon, ...props }: PropsWithChildren<Props>, ref) => {
    return (
      <Button
        ref={ref}
        onClick={onClick}
        style={styles.buttonGradient}
        variant="outline"
        leftSection={icon ? <Icon name={icon} /> : null}
        {...props}
      >
        {children}
      </Button>
    );
  },
);
